import React from 'react';

const BrandLogo = ({ align = 'center', className = '' }) => (
    <div className={`flex items-center gap-3 ${align === 'start' ? 'justify-start' : 'justify-center'} ${className}`}>
        <span className="flex items-center justify-center w-12 h-12 shrink-0 rounded-xl bg-gradient-to-b from-[#1627e2] to-[#000682]">
            <img src={`${process.env.PUBLIC_URL}/logo.svg`} width={32} height={27} alt="" />
        </span>
        <span className="text-lg font-semibold tracking-tight text-gray-900">IT-Burger</span>
    </div>
);

export default BrandLogo;
